import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { NavBarTab, NavBarTabsItem } from "../../components/weui";
import { urls } from "../../urls";

import "./index.css";

export const PayLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname.toLowerCase();
  const isPayEntry = path === urls.feeEntry() || path === urls.fee();
  const isPayments = path.startsWith(urls.payments());

  return (
    <>
      {
        (isPayEntry || isPayments) &&
          <div className="#bgSelf py-2">
            <NavBarTab className="navBar-wrap">
              <NavBarTabsItem
                className={ `navBar-item ${isPayEntry ? "bartleftTop" : ""}` }
                active={ isPayEntry }
                onClick={ e => navigate(urls.fee()) }>充值缴费</NavBarTabsItem>
              <NavBarTabsItem
                className={ `navBar-item ${isPayments ? "bartRightTop" : ""}` }
                active={ isPayments }
                onClick={ e => navigate(urls.payments()) }>缴费记录</NavBarTabsItem>
            </NavBarTab>
          </div>
      }

      <Outlet />
    </>
  );
};
